import React, { useEffect, useState } from 'react';
import { Accordion } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';
import { getApi, postApi } from '../../api/call.api';
import { urlApi } from '../../api/url.api';
import Layout from '../../layout/Layout';
import { loadingHide, loadingShow } from '../../loadingUi/loading.controller';

const Support = () => {
    const [issueList, setIssueList] = useState([]);
    const [activeTab, setActiveTab] = useState(null);

    async function getList() {
        loadingShow();
        let resp = await getApi(urlApi.getIssueList);
        loadingHide();
        if (resp.responseCode === 200) {
            setIssueList(resp.data);
        } else {
            setIssueList([]);
            toast.error(resp.message);
        }
    }

    useEffect(() => {
        getList();
    }, []);

    async function submitIssue(item, description) {
        loadingShow();
        let postData = {
            "issue": item?.issue
        }
        if (description) {
            postData.description = description;
        }
        let resp = await postApi(postData, urlApi.submitIssue);
        loadingHide();
        if (resp.responseCode === 200) {
            setActiveTab(null);
            if (description) {
                if (document.getElementById(`issue-description-${item?._id}`)) {
                    document.getElementById(`issue-description-${item?._id}`).value = '';
                }
            }
            if (document.getElementById("issue-other")) {
                document.getElementById("issue-other").value = '';
            }
            if (document.getElementById(`issue-description-other`)) {
                document.getElementById(`issue-description-other`).value = '';
            }

            toast.success(resp.message);
        } else {
            toast.error(resp.message);
        }
    }

    return (
        <Layout>
            <p className='text-[17px] font-bold mb-2'>Support & Contact</p>

            <div className="text-center">
                <p className='text-md mb-2 font-medium'>For any assistance, please contact our Customer Support team</p>
                <div className='flex flex-wrap gap-4 justify-center'>
                    <p className='text-sm'>Email : <Link to={'mailto:bishal@edwidtech.com'} target='_blank' className='text-primary'>bishal@edwidtech.com</Link></p>
                </div>
            </div>

            <div className="p-4">
                <Accordion activeKey={activeTab}>
                    {
                        issueList?.map((item, index) => {
                            return (
                                <Accordion.Item eventKey={index} key={index}>
                                    <Accordion.Header onClick={() => setActiveTab(prev => prev == index ? null : index)}>{item?.issue}</Accordion.Header>
                                    <Accordion.Body>
                                        <div className="flex flex-col gap-2">
                                            <textarea name="" className='border-2 w-full rounded-lg p-2 text-sm' rows={4} placeholder='Write Your Issue In Brief (Optional)' id={`issue-description-${item?._id}`}></textarea>
                                            <button className='text-sm font-semibold rounded-full bg-primary text-white px-3 py-1.5 ms-auto' onClick={() => submitIssue(item, document.getElementById(`issue-description-${item?._id}`).value)}>Submit</button>
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                            )
                        })
                    }
                    <Accordion.Item eventKey={10000} key={10000}>
                        <Accordion.Header onClick={() => setActiveTab(prev => prev == 10000 ? null : 10000)}>Others</Accordion.Header>
                        <Accordion.Body>
                            <div className="flex flex-col gap-2">
                                <input type="text" className='border-2 w-full rounded-lg p-2 text-sm' placeholder='Describe Your Issue' id='issue-other' />
                                <textarea name="" className='border-2 w-full rounded-lg p-2 text-sm' rows={4} placeholder='Write Your Issue In Brief (Optional)' id={`issue-description-other`}></textarea>
                                <button className='text-sm font-semibold rounded-full bg-primary text-white px-3 py-1.5 ms-auto' onClick={() => submitIssue({ issue: document.getElementById("issue-other").value?.trim() }, document.getElementById(`issue-description-other`).value)?.trim()}>Submit</button>
                            </div>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            </div>
        </Layout>
    )
}

export default Support